import InternalMenuAccordion from "./InternalMenu.Accordion";
import InternalMenuGuides from "./InternalMenu.Guides";

const InternalMenu = {
	Guides: InternalMenuGuides,
	Accordion: InternalMenuAccordion,
};

export default InternalMenu;
